import LINKS from './links';

const STORES = {
  COUPON_DISCOUNT: 'Cupons de desconto',
  DESCRIPTION_OFFER_STORE: 'Oferta da loja:',
  PAGE_TABS: {
    TABS: {
      CATEGORIES: {
        tabName: 'Categorias',
        url: LINKS.SITEMAP,
      },
      COUPONS: {
        tabName: 'Cupons',
        url: LINKS.STORES,
      },
      OFFERS: {
        tabName: 'Ofertas',
        url: LINKS.STORES,
      },
    },
  },
  POPULAR_STORES_LIMIT: 6,
  RELATED_COUPONS: 'Cupons de desconto relacionados',
  STORE_BREADCRUMB_FIRST_ITEM: 'Lojas',
  STORE_COUPONS_BREADCRUMB_SECOND_ITEM: 'Cupons de desconto',
  STORE_COUPONS_BREADCRUMB_THIRD_ITEM: 'Cupom',
  STORE_HEADING_TITLE: 'Encontre cupons das melhores lojas',
};

export default STORES;
